import assetPath from '/app/packages/lebenslauf/components/src/assets/prompt-bold.ttf';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')